import { FC } from "react";

import ArrowRight from "@mui/icons-material/ChevronRight";
import { Box, ListItemIcon } from "@mui/material";

import { parentNodeIconStyles as styles } from "./ParentNodeIcon.styles";

export const ParentNodeIcon: FC<{
  closedDirection: "down" | "right";
  open: boolean;
  color?: string;
}> = ({ closedDirection, open, color }) => {
  let rotate;
  if (closedDirection === "right") {
    rotate = open ? 180 : 0;
  } else {
    rotate = open ? 270 : 90;
  }

  return (
    <Box css={styles.animationContainer({ rotate })}>
      <ListItemIcon css={styles.listItemIcon}>
        <ArrowRight css={styles.arrow(color)} />
      </ListItemIcon>
    </Box>
  );
};
